import { Alert as MuiAlert } from '@mui/material';
import type { AlertProps as MuiAlertProps } from '@mui/material/Alert';

export type AlertProps = MuiAlertProps;

export const Alert = ({ ...rest }: AlertProps): JSX.Element => <MuiAlert {...rest} />;
